"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ReactUtils = _interopRequireDefault(require("../Utils/ReactUtils"));
var _AnimateModule = _interopRequireDefault(require("./Animate.module.scss"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const ANIMATION_CLASSES = animation => {
  switch (animation) {
    case "pop":
      {
        return _AnimateModule.default.pop;
      }
    case "spin":
      {
        return _AnimateModule.default.spin;
      }
    default:
      return null;
  }
};

/**
 * Apply CSS animations to a component, e.g. spins, pops
 */
var _default = ({
  ...props
}) => _ReactUtils.default.render(props.component, {
  ...props.componentProps,
  className: `${props.componentProps?.className} ${ANIMATION_CLASSES(props.animation)}`
});
exports.default = _default;